<template>
  <div class="mt-3">
    <RadioGroup :model-value="modelValue" class="mb-0" @update:model-value="$emit('update:modelValue', $event)">
      <RadioGroupLabel class="block text-sm font-semibold text-gray-900">
        <slot name="label">{{ label }}</slot>
      </RadioGroupLabel>
      <p v-if="description" class="mt-0.5 text-xs italic text-gray-600">{{ description }}</p>
      <div class="flex gap-2 mt-2 flex-col sm:flex-row sm:flex-wrap">
        <RadioGroupOption
          v-for="option in options"
          :key="String(option.value)"
          as="template"
          :value="option.value"
          v-slot="{ checked }"
        >
          <div
            :class="[
              'text-xs cursor-pointer flex items-center px-2.5 py-1.5 border-2 rounded-md shadow-xs focus:outline-hidden transition-colors duration-200 whitespace-nowrap shrink-0',
              checked
                ? 'border-primary-dark bg-primary text-button-font-primary'
                : 'bg-white text-gray-700 hover:bg-primary-light hover:border-primary',
            ]"
          >
            {{ $t(`advisory.${translationPrefix}.${option.value}`) }}
          </div>
        </RadioGroupOption>
      </div>
    </RadioGroup>
    <ErrorMessage :name="name" class="mt-1 text-xs text-red-600" />
  </div>
</template>

<script>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";
import { ErrorMessage } from "vee-validate";

export default {
  components: { RadioGroup, RadioGroupLabel, RadioGroupOption, ErrorMessage },
  props: {
    modelValue: { type: [String, Boolean, Number], default: null },
    name: { type: String, required: true },
    label: { type: String, default: "" },
    description: { type: String, default: "" },
    options: { type: Array, required: true },
    translationPrefix: { type: String, required: true },
  },
  emits: ["update:modelValue"],
};
</script>
